import type { TranslationInterface } from '.';

export const PortugueseLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Escreva uma mensagem...',
  your_issue_has_been_resolved: 'Seu problema foi resolvido!',
  new_conversation: 'Nova conversa',
  welcome_screen_title: 'Bem-vindo ao nosso chat de suporte',
  welcome_screen_description:
    'Estamos aqui para ajudar! Inicie uma conversa e responderemos o mais rápido possível.',
  your_name_placeholder: 'Seu nome',
  your_email_placeholder: 'Seu endereço de email',
  start_chat_button: 'Falar com o suporte',
  start_chat_button_loading: 'Conectando...',
  i_need_more_help: 'preciso de mais ajuda',
  this_was_helpful: 'Isso foi útil',
  optional: 'Opcional',
  no_conversations_yet: 'Nenhuma conversa ainda',
  back_to_conversations: 'Voltar para conversas',
  closed_conversations: 'Conversas fechadas',
  csat_title: 'Como foi a sua conversa?',
  csat_submitted_title: 'Você avaliou a conversa como',
  csat_feedback_placeholder: 'Conte-nos mais... (opcional)',
  follow_up_placeholder: 'Continuar…',
  companion_layout_label: 'Esquema',
  companion_layout_floating: 'Flutuante',
  companion_layout_sidebar: 'Barra lateral',
  companion_layout_fullscreen: 'Ecrã inteiro',
  companion_close: 'Fechar',
  companion_history: 'Histórico de conversas',
  companion_expand_chat: 'Expandir chat',
  companion_sidebar_dock_label: 'Ancoragem',
  companion_sidebar_side_label: 'Lado',
  companion_sidebar_left: 'Esquerda',
  companion_sidebar_right: 'Direita',
  companion_resize_chat: 'Redimensionar chat',
  scroll_to_bottom: 'Deslocar para o fim',
  thinking: 'A pensar…',
  running: 'Em execução…',
  steps: 'passos',
  step_arguments: 'Argumentos',
  step_result: 'Resultado',
  attach_files:
    'Anexar imagens, vídeos, PDFs ou folhas de cálculo (tamanho máximo 25 MB)',
  mark_page_active:
    'Clique em algo na página para o marcar — Esc para cancelar',
  mark_page: 'Marque algo na página para perguntar sobre isso',
  stop_response: 'Parar resposta',
  copy_reply: 'Copiar resposta',
  mentions_empty: 'Sem resultados',
  copied: 'Copiado',
  send_message: 'Enviar mensagem',
  upload_failed: 'Falha no carregamento: {error}',
  remove_attachment: 'Remover anexo',
  json_no_items: 'Sem itens',
  json_no_data: 'Sem dados',
  json_no_chart_data: 'Sem dados para o gráfico',
  json_unsupported: 'Não suportado: {type}',
  json_see_less: 'Ver menos',
  json_phone_agent: 'Agente telefónico',
  json_phone_agent_test: 'Testar via web',
  page_context_remove: 'Remover contexto da página',
  json_see_more: 'Ver mais {count}',
  queued_label: '{count} Na fila',
  remove_queued_message: 'Remover mensagem da fila',
  send_queued_now: 'Enviar mensagens da fila agora',
  turn_failed_message: 'Algo correu mal e a resposta não chegou.',
  turn_failed_retry: 'Tentar novamente',
  page_mark_hint: 'Clique em algo para o marcar',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Caixa',
  page_mark_shape_circle: 'Círculo',
  page_mark_shape_arrow: 'Seta',
  page_mark_shape_bracket: 'Parêntese',
  page_mark_shape_underline: 'Sublinhado',
  page_mark_shape_highlight: 'Realce',
  page_mark_shape_strike_through: 'Rasurado',
  page_mark_shape_crossed_off: 'Riscado em cruz',
  page_mark_shape_aria: 'Forma da marca: {shape}',
  page_mark_note_placeholder: 'Adicionar nota… (Enter para anexar)',
  page_mark_attach: 'Anexar marca',
  page_mark_remove: 'Remover {label}',
  page_mark_region: 'Área marcada',
  page_mark_default_message: 'O que é isto?',
  file_rejected:
    'O tipo de ficheiro não é suportado ou o ficheiro é demasiado grande.',
  dictate: 'Ditar',
  stop_dictation: 'Parar ditado',
  dictation_mic_blocked: 'Permita o acesso ao microfone para ditar',
  dictation_unavailable: 'O ditado não está disponível agora',
  questions_back: 'Voltar',
  questions_next: 'Seguinte',
  questions_send: 'Enviar',
  questions_type_answer: 'Prefiro escrever',
  questions_answer_placeholder: 'Escreva a sua resposta…',
  close_conversation_title: 'Encerrar conversa',
  close_conversation_description:
    'Tem certeza de que deseja encerrar esta conversa?',
  close_conversation_cancel: 'Não',
  close_conversation_confirm: 'Sim',
  dialog_close: 'Fechar',
  zoom_in: 'Ampliar',
  zoom_out: 'Reduzir',
  reset_zoom: 'Redefinir zoom',
  support_chat_aria_label: 'Chat de suporte',
};
